import { BrowserRouter } from "react-router-dom";
import { RouteCombiner, routes } from "./routes";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from "@mui/x-date-pickers";


console.error = (e) => {
  console.warn(e);
}


function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <BrowserRouter>
        <RouteCombiner routes={routes} />
      </BrowserRouter>
    </LocalizationProvider>
  );
}

export default App;
